import debug from "debug";
const createLogger = (namespace: string, ...args: unknown[]) => {
  const logInfo = debug(`${namespace}:${args}:Info:`);
  const logError = debug(`${namespace}:${args}:Error:`);
  const logWarning = debug(`${namespace}:${args}:Warning:`);
  const logDebug = debug(`${namespace}:${args}:Debug:`);
  debug.enable(import.meta.env.VITE_DEBUG);

  return {
    info: (message: string, ...args: unknown[]) => logInfo(message, ...args),
    error: (message: string, ...args: unknown[]) => logError(message, ...args),
    warning: (message: string, ...args: unknown[]) =>
      logWarning(message, ...args),
    debug: (message: string, ...args: unknown[]) => logDebug(message, ...args),
  };
};

export { createLogger };
